import { ReactElement, useState, useMemo } from 'react';
import styled from 'styled-components';
import { DatePicker as MotiliUIDatePicker } from '@motili/ui';
import moment from 'moment-timezone';
import DatePickerLabel from './DatePickerLabel';
import { getDateFormat } from '../../utils/date-time';

const DatePicker = (props: any): ReactElement => {
    const { ...otherProps } = props;

    const updatedProps = {
        ...defaultProps,
        ...otherProps,
    };

    const [focused, setFocused] = useState(updatedProps.focused || false);

    const date = useMemo(() => {
        return typeof updatedProps.date === 'string'
            ? updatedProps.date.length && updatedProps.date !== 'Invalid date'
                ? moment(updatedProps.date)
                : null
            : updatedProps.date;
    }, [updatedProps.date]);

    const onDateChange = (date: moment.Moment) => {
        if (updatedProps.showClearDate && !date && updatedProps.date) {
            return updatedProps.onDateChange(date);
        }
        if (!updatedProps.date || date) {
            return updatedProps.onDateChange(date);
        }
        return updatedProps.onDateChange(updatedProps.date);
    };

    const onFocusChange = ({ focused }: any) => {
        if (updatedProps.onFocusChange) {
            updatedProps.onFocusChange({ focused });
        }
    };

    const adjustMinDate = (day: any, minDate: any) =>
        day.isBefore(minDate, 'day');

    const isDayBlocked = (day: any) => {
        if (updatedProps.isDayBlocked) {
            return updatedProps.isDayBlocked(day);
        }
        return false;
    };

    const minDate = useMemo(() => {
        if (updatedProps.minDate) {
            return updatedProps.minDate;
        }
        if (updatedProps.yearMin) {
            return moment().year(updatedProps.yearMin);
        }
        return undefined;
    }, [updatedProps.minDate, updatedProps.yearMin]);

    const datePickerContainerComponent = (
        <StyledDatePickerWrapped
            {...updatedProps}
            label=''
            date={date}
            minDate={minDate}
            onChange={(date: moment.Moment) => {
                onDateChange(date);
            }}
            focused={focused}
            setFocused={value => {
                setFocused(value);
                onFocusChange(value);
            }}
            isDayBlocked={(day: moment.Moment) => {
                return updatedProps.minDate
                    ? adjustMinDate(day, updatedProps.minDate)
                    : isDayBlocked(day);
            }}
            borderColor={
                updatedProps.borderColor ? updatedProps.borderColor : '#ccc'
            }
        />
    );

    return (
        <>
            {updatedProps.label && (
                <DatePickerLabel
                    required={updatedProps.required}
                    label={updatedProps.label}
                />
            )}
            {datePickerContainerComponent}
        </>
    );
};

const defaultProps: any = {
    isDayBlocked: () => false,
    id: 'datePicker',
    disabled: false,
    displayFormat: getDateFormat(),
    numberOfMonths: 1,
    height: '40px',
};
const StyledDatePickerWrapped = styled(MotiliUIDatePicker)``;

export default DatePicker;
